// src/screens/Marketplace/StoresAll.js
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useActiveStores } from '../../context/ActiveStoresContext';
import backIcon from '../../assets/backspace-icon.png';
import placeholderLogo from '../../assets/placeholder-logo.png';
import './StoresAll.css';

export default function StoresAll() {
  const navigate = useNavigate();
  const { activeStores, loading, error, refetch } = useActiveStores();

  // Sorted, unique, safe list
  const items = useMemo(() => {
    const list = Array.isArray(activeStores) ? activeStores : [];
    const unique = new Map();
    for (const s of list) {
      if (!s?.businessUsername) continue;
      unique.set(s.businessUsername, s);
    }
    return [...unique.values()].sort((a, b) =>
      (a.businessName || '').localeCompare(b.businessName || '')
    );
  }, [activeStores]);

  return (
    <div className="sal-page">
      {/* Top bar */}
      <header className="sal-topbar">
        <button
          className="sal-back"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          title="Back"
        >
          <img src={backIcon} alt="" className="sal-back-img" />
        </button>
        <h1 className="sal-title">SHOP BY STORES</h1>
        <div className="sal-spacer" />
      </header>

      {/* Content */}
      <div className="sal-scroll">
        {loading && (
          <div className="sal-list">
            {Array.from({ length: 6 }).map((_, i) => (
              <div className="sal-row sal-skel" key={i}>
                <div className="sal-logo sal-skel-box" />
                <div className="sal-label sal-skel-line" />
                <div className="sal-chevron-placeholder" />
              </div>
            ))}
          </div>
        )}

        {!loading && error && (
          <div className="sal-empty">
            Failed to load stores.
            <button className="sal-retry" onClick={refetch}>Retry</button>
          </div>
        )}

        {!loading && !error && items.length === 0 && (
          <div className="sal-empty">No active stores yet.</div>
        )}

        {!loading && !error && items.length > 0 && (
          <div className="sal-list">
            {items.map((s) => (
              <button
                key={s.businessUsername}
                className="sal-row"
                onClick={() => navigate(`/store/${s.businessUsername}`)}
                aria-label={`Open ${s.businessName}`}
                title={s.businessName}
              >
                <img
                  className="sal-logo"
                  src={s.businessLogo || placeholderLogo}
                  alt=""
                  onError={(e) => { e.currentTarget.src = placeholderLogo; }}
                />
                <span className="sal-label">
                  {s.businessName || s.businessUsername}
                </span>
                <svg className="sal-chevron" width="18" height="18" viewBox="0 0 24 24" aria-hidden>
                  <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
